import {
  Box, Divider,
  FormHelperText, InputAdornment, Stack, TextField, Typography,
} from '@mui/material';
import RequiredBadge from 'components/RequiredBadge';
import { modifierContext } from 'pages/Merchant/Item/ModifierProvider';
import React, { useContext } from 'react';
import { pluralize } from 'utils/string';

function ItemAmount({
  item, amount, onChange, size,
}) {
  const { loading } = useContext(modifierContext);
  if (loading) {
    return null;
  }
  const servingSize = (item.sizes.find((s) => s.position === size)?.serving_size || 0) * (amount || 0);

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
        <Typography variant="title-lg" marginBottom={1}>
          Select amount
        </Typography>
        <RequiredBadge isSatisfied={amount > 0} />
      </Stack>
      <TextField
        label="Amount"
        variant="outlined"
        fullWidth
        type="number"
        value={amount}
        onChange={(e) => onChange(e.target.value && Number(e.target.value))}
        InputProps={{
          endAdornment: <InputAdornment position="start">
            <Typography
              variant="label-md"
            >
              {item?.catering_label || 'Person'}
            </Typography>
                        </InputAdornment>,
        }}
        data-testid="item-amount"
      />
      {servingSize > 0 && (
        <FormHelperText
          sx={{
            fontSize: '14px',
            lineHeight: '20px',
            letterSpacing: '0px',
            fontWeight: 700,
            color: 'text.primary',
            pl: 2,
          }}
        >
          Serves
          {' '}
          {servingSize}
          {' '}
          {pluralize('person', servingSize)}
        </FormHelperText>
      )}
      <Divider sx={{ mt: 1, mb: 2 }} />
    </Box>
  );
}

export default ItemAmount;
